









import { defineComponent } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';

const name = 'ttam-creative-deeplink-dpa-input-form-label';

export default defineComponent({
  name,
  components: {
    QuestionTooltip,
  },
  setup(props, { emit }) {
    return {
      name,
    };
  },
});
